import { ButtonA11Y } from '@ping/uikit';
import CaretDownIcon from '@ping/assets/Icon/caret-down.svg';

import style from './style.module.scss';

interface IMarketPairsDropdownTriggerProps {
  children: React.ReactNode;
  isVisible: boolean;
  setIsDropdownVisible: (fn: (isVisible: boolean) => boolean) => void;
}

export const MarketPairsDropdownTrigger = ({
  children,
  isVisible,
  setIsDropdownVisible,
}: IMarketPairsDropdownTriggerProps) => {
  return (
    <>
      <ButtonA11Y
        className={style['market-pairs-dropdown-trigger']}
        aria-expanded={isVisible}
        onPress={() => setIsDropdownVisible(s => !s)}
      >
        <CaretDownIcon className={style['market-pairs-dropdown-trigger__icon']} data-expanded={isVisible} />
      </ButtonA11Y>

      <div className={style['market-pairs-dropdown-underlay']} aria-hidden={!isVisible} />
      <div className={style['market-pairs-dropdown-menu']} aria-hidden={!isVisible}>
        {children}
      </div>
    </>
  );
};
